export function getInitials (string) {
    var names = string.split(' '),
        initials = names[0].substring(0, 1).toUpperCase();
    
    if (names.length > 1) {
        initials += names[names.length - 1].substring(0, 1).toUpperCase();
    }
    return initials;
}

export function safeInt (string) {
    return Number(string.replace("$","").replace(/,/g,""));
}
